import React from 'react'
import { Grid as BaseGrid, Hidden as BaseHidden, styled } from '@mui/material'
import { CheckBox as BaseCheckBox, Button as BaseButton } from '@chilecompra/react-kit/components'

export const CheckBox = styled(BaseCheckBox)`
  .MuiCheckbox-root {
    margin: 0;
    padding: 0;
  }
  &.MuiFormControlLabel-root {
    margin: 0 8px 0 0;
  }
`

export const Conditions = styled('div')`
  align-items: center;
  background: rgba(0, 100, 255, 0.03);
  border-radius: 4px;
  border: 1px solid ${props => props.theme.palette.brand.primary};
  color: ${props => props.theme.palette.brand.black1};
  display: flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-top: 22px;
  padding: 18px 19px 19px 17px;

  ${props => props.theme.breakpoints.down('sm')} {
    text-align: center;
    padding: 14px 10px 15px 10px;
  }
`

export const DesktopNavigation = styled('div')`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 30px;
  margin: 0;
  width: 100%;
`

export const Hidden = styled(BaseHidden)``

export const Image = styled('img')`
  height: ${props => props.height};
  width: 100%;
`

export const Instructions = styled('section')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  margin-top: 28px;

  ${props => props.theme.breakpoints.down('sm')} {
    margin-top: 22px;
    text-align: left;
  }
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand[props.color]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-decoration-line: ${props => (props.underline ? 'underline' : 'inherit')};

  &:hover {
    color: ${({ color, theme }) => {
      switch (color) {
        case 'primary':
          return theme.palette.blue[35]
        case 'black2':
          return theme.palette.brand.black3
        default:
          return 'inherit'
      }
    }};
  }
`

export const MobileButtons = styled(BaseButton)`
  flex-grow: 1;
  width: 100%;
`

export const MobileNavigation = styled('div')`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: center;
  margin-bottom: 40px;
  width: 100%;
`

export const Root = styled('div')`
  margin: 0;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth || 'initial'};
  padding: ${props => props.padding || '0'};
`

export const TermsLink = styled('a')``

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 27px;
  font-style: normal;
  font-weight: 700;
  line-height: 31px;

  ${props => props.theme.breakpoints.down('sm')} {
    margin: 0;
    text-align: left;
  }
`

export const ToastContainer = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 15px;

  ${props => props.theme.breakpoints.between('xs', 'lg')} {
    margin-left: 0;
    margin-top: 20px;
    width: 100%;
  }

  & span {
    font-feature-settings:
      'liga' off,
      'clig' off;
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    color: ${props => props.theme.palette.brand.black1};
  }
`
